// extracted by mini-css-extract-plugin
export var videoWrapper = "GalleryVideo-module--videoWrapper--f9699";
export var video = "GalleryVideo-module--video--c41c0";